import {translate} from "vue-gettext";

const {pgettext: $pgettext} = translate;

export default {
    pending: 'pending',
    invoice_uploaded: 'invoice_uploaded',
    invoice_rejected: 'invoice_rejected',
    paid: 'paid',
    all: 'all',

    default() {
        return this.invoice_uploaded
    },

    label(status) {
        const labels = {
            [this.pending]: $pgettext('payout.status', 'Pending Invoice'),
            [this.invoice_uploaded]: $pgettext('payout.status', 'Invoice Uploaded'),
            [this.invoice_rejected]: $pgettext('payout.status', 'Invoice Rejected'),
            [this.paid]: $pgettext('payout.status', 'Paid'),
            [this.all]: $pgettext('payout.status', 'All')
        }
        return labels[status] || status
    },

    color(status) {
        const colors = {
            [this.pending]: 'warning',
            [this.invoice_uploaded]: 'info',
            [this.invoice_rejected]: 'danger',
            [this.paid]: 'success'
        }
        return colors[status] || 'light'
    },

    icon(status) {
        const icons = {
            [this.pending]: 'cipClock',
            [this.invoice_uploaded]: 'cipDotBlue',
            [this.invoice_rejected]: 'cipDotRed',
            [this.paid]: 'cipDotGreen'
        }
        return icons[status] || 'cipDot'
    },

    options(includeAll = false) {
        const opts = [
            { value: this.pending, label: $pgettext('payout.status', 'Pending Invoice') },
            { value: this.invoice_uploaded, label: $pgettext('payout.status', 'Invoice Uploaded') },
            { value: this.invoice_rejected, label: $pgettext('payout.status', 'Invoice Rejected') },
            { value: this.paid, label: $pgettext('payout.status', 'Paid') }
        ]

        if (includeAll) {
            opts.unshift({
                value: this.all,
                label: $pgettext('payout.status', 'All')
            })
        }

        return opts
    },

    getSelectOptions(context = 'admin-payout', includeAll = true) {
        const opts = [
            { value: this.pending, label: $pgettext(context, 'Pending Invoice') },
            { value: this.invoice_uploaded, label: $pgettext(context, 'Invoice Uploaded') },
            { value: this.invoice_rejected, label: $pgettext(context, 'Invoice Rejected') },
            { value: this.paid, label: $pgettext(context, 'Paid') }
        ]

        if (includeAll) {
            opts.unshift({
                value: this.all,
                label: $pgettext(context, 'All')
            })
        }

        return opts
    },

    values() {
        return [this.pending, this.invoice_uploaded, this.invoice_rejected, this.paid]
    }
}
